export default "/static/91882709c053a27c.png"